import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominaDocumentosLayoutsh2h', NominaDocumentosLayoutsh2h)

function NominaDocumentosLayoutsh2h($http) {
  this.get = function (idProyecto, idNomina) {
    return $http.get('/api/nominas/nomina/documentos/layoutsh2h', {
      params: {
        id_proyecto: idProyecto,
        id_nomina: idNomina,
      },
      schema: this.schema,
    })
  }.bind(this)

  this.post = function (idProyecto, idNomina, idBanco, idCuenta, idMoneda, codigoCliente, tipoCambio, fechaPago, pin, token, seleccionados, total, interbancario, masivo, monedaId) {
    return $http.post('/api/nominas/nomina/documentos/layoutsh2h', {seleccionados: seleccionados}, {
      params: {
        id_proyecto: idProyecto,
        id_nomina: idNomina,
        id_banco: idBanco,
        id_cuenta: idCuenta,
        id_moneda: idMoneda,
        codigo_cliente: codigoCliente,
        tipo_cambio: tipoCambio,
        fecha_pago: fechaPago.toYMD(),
        pin: pin,
        token: token,
        total: total,
        interbancario: interbancario,
        masivo: masivo,
        moneda_id: monedaId,
      },
      schema: this.schema,
      clearCache: 'nominas',
    })
  }.bind(this)

  this.schema = {
    captura_fecha: 'datetime',
    colaboradores: 'number',
    completado: 'boolean',
    encabezado_error: 'boolean',
    todos_pagos_error: 'boolean',
    fecha_pago: 'date',
    id_layout: 'number',
    indice: 'number',
    interbancario: 'boolean',
    masivo: 'boolean',
    tipo_cambio: 'number',
    total: 'number',
    total_aplicado: 'number',
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Documentos/Layoutsh2h.js